(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-faq"] && !Shopify.designMode) return;
  try {
    
  class ContactUsFaq extends HTMLElement {
    connectedCallback() {
      this.linkifyAnswers();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    linkifyAnswers() {
      const urlPattern = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
      const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          if (!node.parentElement.closest('.faq-answer-text')) return NodeFilter.FILTER_REJECT;
          if (node.parentElement.closest('a, script, style')) return NodeFilter.FILTER_REJECT;
          if (!urlPattern.test(node.nodeValue) && !emailPattern.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          urlPattern.lastIndex = 0;
          emailPattern.lastIndex = 0;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        const text = node.nodeValue;
        const matches = [];
        text.replace(urlPattern, (match, value, index) => {
          matches.push({ index, value, type: 'url' });
          return match;
        });
        text.replace(emailPattern, (match, value, index) => {
          matches.push({ index, value, type: 'email' });
          return match;
        });
        matches.sort((a, b) => a.index - b.index);

        let cursor = 0;
        matches.forEach((match) => {
          if (match.index < cursor) return;
          if (match.index > cursor) fragment.append(document.createTextNode(text.slice(cursor, match.index)));
          const trailing = match.value.match(/[.,;:!?)]$/)?.[0] || '';
          const value = trailing ? match.value.slice(0, -1) : match.value;
          const link = document.createElement('a');
          link.textContent = value;
          if (match.type === 'email') {
            link.href = `mailto:${value}`;
          } else {
            link.href = value.startsWith('www.') ? `https://${value}` : value;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
          }
          fragment.append(link);
          if (trailing) fragment.append(document.createTextNode(trailing));
          cursor = match.index + match.value.length;
        });
        if (cursor < text.length) fragment.append(document.createTextNode(text.slice(cursor)));
        node.replaceWith(fragment);
      });
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const question = event.target.closest('.faq-question');
      if (!question || !this.contains(question)) return;
      event.preventDefault();
      question.click();
    }

    onClick(event) {
      const groupHeading = event.target.closest('.js-faqGroupHeading');
      if (groupHeading && this.contains(groupHeading)) {
        if (groupHeading.dataset.allowExpand !== 'true') return;
        const group = groupHeading.closest('.js-faqGroup');
        if (!group) return;
        const expanded = group.getAttribute('aria-expanded') !== 'false';
        group.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        return;
      }

      const question = event.target.closest('.faq-question');
      if (!question || !this.contains(question)) return;
      const item = question.closest('.js-faqItem');
      if (!item) return;

      this.querySelectorAll('.js-faqItem.open').forEach((openItem) => {
        if (openItem !== item) this.setItemOpen(openItem, false);
      });
      this.setItemOpen(item, !item.classList.contains('open'));
    }

    setItemOpen(item, open) {
      item.classList.toggle('open', open);
      const toggle = item.querySelector('.accordion-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      const question = item.querySelector('.faq-question');
      if (question) question.setAttribute('aria-expanded', open ? 'true' : 'false');
      const expandAnim = item.querySelector('animate[data-faq-arrow="expand"]');
      const collapseAnim = item.querySelector('animate[data-faq-arrow="collapse"]');
      try {
        if (open && expandAnim) expandAnim.beginElement();
        if (!open && collapseAnim) collapseAnim.beginElement();
      } catch (error) {}
    }
  }

  if (!customElements.get('contact-us-faq')) {
    customElements.define('contact-us-faq', ContactUsFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eligible-package-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.eptReady) return;
      root.dataset.eptReady = 'true';
      const source = root.querySelector('.eligible-package-tabs__source');
      const nav = root.querySelector('.eligible-package-tabs__nav');
      const panelHost = root.querySelector('.eligible-package-tabs__panels');
      if (source && nav && panelHost) {
        source.querySelectorAll('.eligible-package-tabs__tab-block').forEach((block) => {
          const tab = block.querySelector('[role="tab"]');
          const panel = block.querySelector('[role="tabpanel"]');
          if (tab && panel) { nav.appendChild(tab); panelHost.appendChild(panel); }
          block.remove();
        });
        source.remove();
      }
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      const updateTabAlignment = () => {
        if (!nav || window.matchMedia('(max-width: 749px)').matches) {
          nav?.classList.remove('is-overflowing');
          nav?.style.removeProperty('--ept-tab-scale');
          return;
        }
        const styles = window.getComputedStyle(root);
        const tabWidth = parseFloat(styles.getPropertyValue('--ept-tab-width')) || 0;
        const tabGap = parseFloat(styles.getPropertyValue('--ept-tab-gap')) || 0;
        const requiredWidth = (tabs.length * tabWidth) + (Math.max(tabs.length - 1, 0) * tabGap);
        const scale = requiredWidth ? Math.min(1, nav.clientWidth / requiredWidth) : 1;
        nav.style.setProperty('--ept-tab-scale', scale.toFixed(4));
        nav.classList.remove('is-overflowing');
      };
      updateTabAlignment();
      window.addEventListener('resize', updateTabAlignment);
      if (window.ResizeObserver && nav) new ResizeObserver(updateTabAlignment).observe(nav);
      const scrollbarUpdates = [];
      const scrollerStates = [];
      const resetProductScroll = (state) => {
        if (!state || !state.scroller) return;
        window.clearTimeout(state.snapTimer);
        state.resetting = true;
        state.scroller.scrollLeft = 0;
        state.update();
        requestAnimationFrame(() => {
          state.scroller.scrollLeft = 0;
          state.update();
          requestAnimationFrame(() => { state.resetting = false; });
        });
      };
      const activate = (index) => {
        // Reset every panel so a later tab switch can never restore a stale
        // horizontal position from a previously active product list.
        scrollerStates.forEach(resetProductScroll);
        tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (panels[i]) {
          panels[i].hidden = !active;
          panels[i].classList.toggle('is-active', active);

          if (active) resetProductScroll(scrollerStates.find((state) => panels[i].contains(state.scroller)));
        }
        if (active) requestAnimationFrame(() => scrollbarUpdates.forEach((update) => update()));
        });
      };
      tabs.forEach((tab, i) => tab.addEventListener('click', () => {
        activate(i);
        if (window.matchMedia('(max-width: 749px)').matches) {
          const nav = tab.closest('.eligible-package-tabs__nav');
          if (nav) {
            const target = tab.offsetLeft - ((nav.clientWidth - tab.offsetWidth) / 2);
            const max = Math.max(nav.scrollWidth - nav.clientWidth, 0);
            nav.scrollTo({ left: Math.min(Math.max(target, 0), max), behavior: 'smooth' });
          }
        }
      }));
      root.querySelectorAll('.eligible-package-tabs__scroller').forEach((scroller) => {
        const bar = scroller.parentElement.querySelector('.eligible-package-tabs__scrollbar span');
        const track = scroller.parentElement.querySelector('.eligible-package-tabs__scrollbar');
        const update = () => {
          if (!bar || !track) return;
          if (window.matchMedia('(max-width: 749px)').matches) {
            const styles = window.getComputedStyle(root);
            const configuredWidth = parseFloat(styles.getPropertyValue('--ept-mobile-card-width')) || scroller.clientWidth;
            const nextCardPeek = parseFloat(styles.getPropertyValue('--ept-mobile-next-card-peek')) || 0;
            const cardGap = parseFloat(window.getComputedStyle(scroller.querySelector('.eligible-package-tabs__track')).gap) || 0;
            const availableWidth = Math.max(scroller.clientWidth - cardGap - nextCardPeek, 0);
            scroller.style.setProperty('--ept-visible-card-width', `${Math.min(configuredWidth, availableWidth)}px`);
          } else {
            scroller.style.removeProperty('--ept-visible-card-width');
          }
          const scrollWidth = scroller.scrollWidth;
          const clientWidth = scroller.clientWidth;
          const maxScroll = Math.max(scrollWidth - clientWidth, 0);
          const trackWidth = track.getBoundingClientRect().width;
          if (!trackWidth || !scrollWidth || !maxScroll) {
            bar.style.width = '100%';
            bar.style.transform = 'translate3d(0, 0, 0)';
            return;
          }
          const thumbWidth = (clientWidth / scrollWidth) * trackWidth;
          const maxThumbLeft = Math.max(trackWidth - thumbWidth, 0);
          const thumbLeft = (scroller.scrollLeft / maxScroll) * maxThumbLeft;
          bar.style.width = `${thumbWidth}px`;
          bar.style.transform = `translate3d(${thumbLeft}px, 0, 0)`;
        };
        let snapTimer;
        const state = { scroller, update, snapTimer: null, resetting: false };
        scrollerStates.push(state);
        const snapToNearestCard = () => {
          if (state.resetting) return;
          const items = [...scroller.querySelectorAll('.eligible-package-tabs__item')];
          if (!items.length) return;
          const maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
          const scrollerLeft = scroller.getBoundingClientRect().left;
          const scrollbarLeft = track.getBoundingClientRect().left;
          const targetLeft = scrollbarLeft - scrollerLeft;
          let target = 0;
          let distance = Infinity;
          items.forEach((item, itemIndex) => {
            const position = itemIndex === items.length - 1 ? maxScroll : Math.min(Math.max(item.offsetLeft - targetLeft, 0), maxScroll);
            const nextDistance = Math.abs(position - scroller.scrollLeft);
            if (nextDistance < distance) { distance = nextDistance; target = position; }
          });
          if (Math.abs(target - scroller.scrollLeft) > 2) scroller.scrollTo({ left: target, behavior: 'smooth' });
        };
        scroller.addEventListener('scroll', () => {
          update();
          if (state.resetting) return;
          window.clearTimeout(snapTimer);
          snapTimer = window.setTimeout(snapToNearestCard, 120);
          state.snapTimer = snapTimer;
        }, { passive: true });
        scroller.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('a, button, select, input, label, textarea')) return;
          const startX = event.clientX;
          const startLeft = scroller.scrollLeft;
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture(event.pointerId);
          const move = (moveEvent) => { scroller.scrollLeft = startLeft - (moveEvent.clientX - startX); };
          const end = () => {
            scroller.classList.remove('is-dragging');
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', end);
          };
          window.addEventListener('pointermove', move, { passive: true });
          window.addEventListener('pointerup', end, { once: true });
        });
        if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
        window.addEventListener('resize', update);
        scrollbarUpdates.push(update);
        requestAnimationFrame(update);
      });
      root.addEventListener('submit', (event) => {
        const form = event.target.closest('.eligible-package-card__form');
        if (!form || !root.contains(form)) return;

        event.preventDefault();

        const submitButton = event.submitter || form.querySelector('[data-ept-add]');
        if (submitButton && submitButton.disabled) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData(form);

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-disabled', 'true');
        }

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(submitButton || form);
        }

        fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
            return response.json();
          })
          .then((response) => {
            if (response.status) throw new Error(response.description || 'Unable to add this product to the cart.');

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open(submitButton || form);
            } else {
              window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              return;
            }

            if (typeof window.freeShippMsg === 'function') window.freeShippMsg();
          })
          .catch((error) => {
            console.error('Eligible package add to cart failed:', error);
          })
          .finally(() => {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-disabled');
            }
          });
      });
      root.addEventListener('change', (event) => { const select = event.target.closest('[data-ept-variant]'); if (!select) return; const option = select.selectedOptions[0]; const card = select.closest('.eligible-package-card'); if (!option || !card) return; card.querySelector('[data-ept-price]').textContent = option.dataset.price; const compare = card.querySelector('[data-ept-compare]'); compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; const discount = card.querySelector('.eligible-package-card__discount'); if (discount) { discount.classList.toggle('is-hidden', !option.dataset.save); const saving = discount.querySelector('strong'); if (saving) saving.textContent = option.dataset.save || ''; } const image = card.querySelector('.eligible-package-card__image'); if (image && option.dataset.image) { image.src = option.dataset.image; image.srcset = option.dataset.imageSrcset || ''; image.sizes = '(min-width: 750px) 360px, 78vw'; if (option.dataset.imageAlt) image.alt = option.dataset.imageAlt; } card.querySelectorAll('[data-ept-link]').forEach((link) => { link.href = option.dataset.url; }); const add = card.querySelector('[data-ept-add]'); if (add) add.disabled = option.dataset.available !== 'true'; });
      activate(0);
    };
    document.querySelectorAll('.eligible-package-tabs').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.eligible-package-tabs')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["install-video-tabs"] && !Shopify.designMode) return;
  try {
    
  function initInstallVideoTabs(section) {
    if (!section || section.dataset.installVideoTabsInitialized === 'true') return;
    section.dataset.installVideoTabsInitialized = 'true';

    const panelsContainer = section.querySelector('[data-install-video-panels]');
    if (panelsContainer) {
      section.querySelectorAll('[data-install-video-panel]').forEach((panel) => {
        panelsContainer.appendChild(panel);
      });
    }

    const tabs = [...section.querySelectorAll('[data-install-video-tab]')];
    const panels = [...section.querySelectorAll('[data-install-video-panel]')];
    const tabsList = section.querySelector('.install-video-tabs-list');
    const scrollbar = section.querySelector('.install-video-tabs-scrollbar');
    const scrollbarThumb = section.querySelector('.install-video-tabs-scrollbar-thumb');
    let scrollbarHideTimer;
    const dialog = section.querySelector('.js-installVideoDialog');
    const frame = section.querySelector('.js-installVideoFrame');
    const closeButton = section.querySelector('.js-installVideoClose');

    const updateTabsScrollbar = () => {
      if (!tabsList) return;
      const trackWidth = Math.max(0, tabsList.clientWidth - 8);
      const canScroll = tabsList.scrollWidth > tabsList.clientWidth;
      const thumbWidth = canScroll
        ? Math.max(32, trackWidth * tabsList.clientWidth / tabsList.scrollWidth)
        : trackWidth;
      const maxLeft = Math.max(0, trackWidth - thumbWidth);
      const scrollRange = tabsList.scrollWidth - tabsList.clientWidth;
      const thumbLeft = scrollRange > 0 ? tabsList.scrollLeft / scrollRange * maxLeft : 0;
      if (scrollbarThumb) {
        scrollbarThumb.style.width = `${thumbWidth}px`;
        scrollbarThumb.style.transform = `translateX(${thumbLeft}px)`;
      }
      if (scrollbar) {
        scrollbar.style.display = 'block';
        scrollbar.style.opacity = '1';
        scrollbar.style.visibility = 'visible';
      }
      tabsList.classList.toggle('has-tabs-scroll', canScroll);
    };

    const handleTabsScroll = () => {
      updateTabsScrollbar();
      if (!scrollbar) return;
      scrollbar.style.opacity = '1';
      scrollbar.style.visibility = 'visible';
      clearTimeout(scrollbarHideTimer);
      scrollbarHideTimer = window.setTimeout(() => {
        scrollbar.style.opacity = '0';
        scrollbar.style.visibility = 'hidden';
      }, 500);
    };

    let scrollbarDrag = null;
    const getScrollbarMetrics = () => {
      const trackWidth = Math.max(0, tabsList.clientWidth - 8);
      const thumbWidth = scrollbarThumb?.offsetWidth || trackWidth;
      const maxLeft = Math.max(0, trackWidth - thumbWidth);
      return { trackWidth, thumbWidth, maxLeft };
    };

    const startScrollbarDrag = (event) => {
      if (!tabsList || window.matchMedia('(min-width: 750px)').matches) return;
      const metrics = getScrollbarMetrics();
      scrollbarDrag = { pointerId: event.pointerId, startX: event.clientX, startLeft: tabsList.scrollLeft, maxLeft: metrics.maxLeft, scrollRange: tabsList.scrollWidth - tabsList.clientWidth };
      tabsList.setPointerCapture(event.pointerId);
      event.preventDefault();
    };

    const moveScrollbarDrag = (event) => {
      if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
      const delta = event.clientX - scrollbarDrag.startX;
      const ratio = scrollbarDrag.maxLeft > 0 ? scrollbarDrag.scrollRange / scrollbarDrag.maxLeft : 0;
      tabsList.scrollLeft = scrollbarDrag.startLeft + delta * ratio;
      event.preventDefault();
    };

    const stopScrollbarDrag = (event) => {
      if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
      scrollbarDrag = null;
      if (tabsList.hasPointerCapture(event.pointerId)) tabsList.releasePointerCapture(event.pointerId);
    };

    const centerTab = (tab) => {
      if (!tabsList || !tab || window.matchMedia('(min-width: 750px)').matches) return;
      const left = tab.offsetLeft - (tabsList.clientWidth - tab.offsetWidth) / 2;
      const maxLeft = tabsList.scrollWidth - tabsList.clientWidth;
      tabsList.scrollTo({ left: Math.max(0, Math.min(left, maxLeft)), behavior: 'smooth' });
      window.requestAnimationFrame(updateTabsScrollbar);
    };

    const selectTab = (id) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.installVideoTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.installVideoPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      centerTab(tabs.find((tab) => tab.dataset.installVideoTab === id));
    };

    const clearVideo = () => {
      if (frame) frame.textContent = '';
    };

    const closeVideo = () => {
      if (dialog?.open) dialog.close();
    };

    const getYouTubeEmbedUrl = (url) => {
      try {
        const parsed = new URL(url, window.location.origin);
        let id = '';
        if (parsed.hostname.includes('youtu.be')) id = parsed.pathname.slice(1);
        if (parsed.hostname.includes('youtube.com')) id = parsed.searchParams.get('v') || parsed.pathname.split('/').pop();
        if (!id) return '';
        return `https://www.youtube.com/embed/${id}?autoplay=1&enablejsapi=1`;
      } catch (error) {
        return '';
      }
    };

    const openVideo = (button) => {
      const url = button.dataset.videoUrl;
      if (!url || !frame) return;

      clearVideo();
      if (button.dataset.videoType === 'youtube') {
        const embedUrl = getYouTubeEmbedUrl(url);
        if (!embedUrl) return;
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.title = button.dataset.videoTitle || 'Video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
      } else {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        frame.appendChild(video);
      }

      if (dialog?.showModal) dialog.showModal();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab.dataset.installVideoTab));
    });

    tabsList?.addEventListener('scroll', handleTabsScroll, { passive: true });
    scrollbarThumb?.addEventListener('pointerdown', startScrollbarDrag);
    tabsList?.addEventListener('pointermove', moveScrollbarDrag);
    tabsList?.addEventListener('pointerup', stopScrollbarDrag);
    tabsList?.addEventListener('pointercancel', stopScrollbarDrag);
    window.addEventListener('resize', updateTabsScrollbar);

    section.querySelectorAll('.js-installVideoOpen').forEach((button) => {
      button.addEventListener('click', () => openVideo(button));
    });

    closeButton?.addEventListener('click', closeVideo);
    dialog?.addEventListener('close', clearVideo);
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeVideo();
    });

    if (tabs[0]) selectTab(tabs[0].dataset.installVideoTab);
    updateTabsScrollbar();
  }

  document.querySelectorAll('[data-install-video-tabs]').forEach(initInstallVideoTabs);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-install-video-tabs]').forEach(initInstallVideoTabs);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scroll-cards"] && !Shopify.designMode) return;
  try {
    
  class ProductScrollCards extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this));
      this.updateScrollbar = this.updateScrollbar.bind(this);
      this.initScrollbar = this.initScrollbar.bind(this);
      this.startDrag = this.startDrag.bind(this);
      this.onDragMove = this.onDragMove.bind(this);
      this.endDrag = this.endDrag.bind(this);
      this.cancelClick = this.cancelClick.bind(this);
      this.queueSnap = this.queueSnap.bind(this);
      this.snapToNearestCard = this.snapToNearestCard.bind(this);
      this.snapInDragDirection = this.snapInDragDirection.bind(this);
      requestAnimationFrame(this.initScrollbar);
    }

    disconnectedCallback() {
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.updateScrollbar);
        this.scroller.removeEventListener('scroll', this.queueSnap);
        this.scroller.removeEventListener('pointerdown', this.startDrag);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.updateScrollbar);
      window.removeEventListener('pointermove', this.onDragMove);
      window.removeEventListener('pointerup', this.endDrag);
      window.removeEventListener('pointercancel', this.endDrag);
      window.clearTimeout(this.clickBlockTimer);
      window.clearTimeout(this.snapTimer);
    }

    initScrollbar() {
      this.scroller = this.querySelector('.product-scroll-cards__scroller');
      this.scrollbar = this.querySelector('.product-scroll-cards__scrollbar');
      this.scrollbarThumb = this.querySelector('.product-scroll-cards__scrollbar-thumb');

      if (!this.scroller || !this.scrollbar || !this.scrollbarThumb) {
        setTimeout(this.initScrollbar, 50);
        return;
      }

      if (this.scrollbarInitialized) return;
      this.scrollbarInitialized = true;
      this.scroller.addEventListener('scroll', this.updateScrollbar, { passive: true });
      this.scroller.addEventListener('scroll', this.queueSnap, { passive: true });
      this.scroller.addEventListener('pointerdown', this.startDrag);
      window.addEventListener('resize', this.updateScrollbar);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.updateScrollbar);
        this.resizeObserver.observe(this.scroller);
        this.resizeObserver.observe(this.querySelector('.product-scroll-cards__track'));
        this.resizeObserver.observe(this.scrollbar);
      }

      requestAnimationFrame(this.updateScrollbar);
      setTimeout(this.updateScrollbar, 100);
      setTimeout(this.updateScrollbar, 300);
      setTimeout(this.updateScrollbar, 800);
      this.querySelectorAll('img').forEach((image) => {
        image.addEventListener('load', this.updateScrollbar, { once: true });
      });
    }

    startDrag(event) {
      if (!this.scroller || event.button !== 0) return;
      if (event.pointerType !== 'mouse') return;
      if (event.target.closest('a, button, select, input, label, textarea')) return;

      event.preventDefault();
      window.clearTimeout(this.snapTimer);
      this.isDragging = true;
      this.isSnapping = false;
      this.dragStartX = event.clientX;
      this.dragStartScrollLeft = this.scroller.scrollLeft;
      this.dragStartedAt = performance.now();
      this.dragMoved = false;
      this.lastDragX = event.clientX;
      this.lastDragTime = this.dragStartedAt;
      this.dragVelocity = 0;
      this.scroller.classList.add('is-dragging');
      this.scroller.setPointerCapture(event.pointerId);
      window.addEventListener('pointermove', this.onDragMove, { passive: true });
      window.addEventListener('pointerup', this.endDrag, { once: true });
      window.addEventListener('pointercancel', this.endDrag, { once: true });
    }

    onDragMove(event) {
      if (!this.isDragging || !this.scroller) return;

      const deltaX = event.clientX - this.dragStartX;
      const now = performance.now();
      const elapsed = Math.max(now - this.lastDragTime, 1);
      const moveDelta = event.clientX - this.lastDragX;
      const nextScrollLeft = this.dragStartScrollLeft - deltaX;

      if (Math.abs(deltaX) > 3) this.dragMoved = true;
      this.dragVelocity = moveDelta / elapsed;
      this.scroller.scrollLeft = nextScrollLeft;
      this.lastDragX = event.clientX;
      this.lastDragTime = now;
      this.updateScrollbar();
    }

    endDrag() {
      if (!this.scroller) return;

      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this.onDragMove);
      window.removeEventListener('pointerup', this.endDrag);
      window.removeEventListener('pointercancel', this.endDrag);

      if (this.dragMoved) {
        window.clearTimeout(this.snapTimer);
        this.snapInDragDirection();
        this.clickBlockActive = true;
        window.addEventListener('click', this.cancelClick, true);
        window.clearTimeout(this.clickBlockTimer);
        this.clickBlockTimer = window.setTimeout(() => {
          this.clickBlockActive = false;
          window.removeEventListener('click', this.cancelClick, true);
        }, 300);
      }
    }

    queueSnap() {
      if (this.isDragging || this.isSnapping || !this.scroller) return;
      if (window.matchMedia('(max-width: 749px)').matches) return;
      window.clearTimeout(this.snapTimer);
      this.snapTimer = window.setTimeout(this.snapToNearestCard, 120);
    }

    getCardPositions() {
      if (!this.scroller) return [];

      const items = Array.from(this.querySelectorAll('.product-scroll-cards__item'));
      const scrollerLeft = this.scroller.getBoundingClientRect().left;
      const scrollbarLeft = this.scrollbar ? this.scrollbar.getBoundingClientRect().left : scrollerLeft;
      const targetLeft = scrollbarLeft - scrollerLeft;
      const maxScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);

      return items.map((item) => Math.min(Math.max(item.offsetLeft - targetLeft, 0), maxScroll));
    }

    scrollToCardPosition(left) {
      if (!this.scroller || Math.abs(left - this.scroller.scrollLeft) < 2) return;

      this.isSnapping = true;
      this.scroller.scrollTo({ left, behavior: 'smooth' });
      window.clearTimeout(this.snapTimer);
      this.snapTimer = window.setTimeout(() => {
        this.isSnapping = false;
        this.updateScrollbar();
      }, 320);
    }

    snapInDragDirection() {
      if (!this.scroller) return;

      const positions = this.getCardPositions();
      if (!positions.length) return;

      const currentLeft = this.scroller.scrollLeft;
      const maxScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
      const movedScroll = currentLeft - this.dragStartScrollLeft;
      const attemptedScroll = this.dragStartScrollLeft - (this.lastDragX - this.dragStartX);
      const edgeTolerance = 2;

      if (Math.abs(movedScroll) <= edgeTolerance) {
        this.updateScrollbar();
        return;
      }

      if (this.dragStartScrollLeft <= edgeTolerance && attemptedScroll < this.dragStartScrollLeft) {
        this.updateScrollbar();
        return;
      }

      if (this.dragStartScrollLeft >= maxScroll - edgeTolerance && attemptedScroll > this.dragStartScrollLeft) {
        this.updateScrollbar();
        return;
      }

      const dragDistance = Math.abs(this.dragStartX - this.lastDragX);
      const dragDuration = Math.max(this.lastDragTime - this.dragStartedAt, 1);
      const dragSpeed = dragDistance / dragDuration;
      const averageStep = positions.length > 1 ? Math.abs(positions[1] - positions[0]) : this.scroller.clientWidth;
      const lightSwipeDistance = Math.min(Math.max(averageStep * 0.12, 24), 48);
      const quickSwipeSpeed = 0.22;
      const shouldAdvance = dragDistance >= lightSwipeDistance || dragSpeed >= quickSwipeSpeed || Math.abs(this.dragVelocity) >= quickSwipeSpeed;

      if (!shouldAdvance) {
        this.snapToNearestCard();
        return;
      }

      let startIndex = 0;
      let nearestStartDistance = Infinity;
      positions.forEach((position, index) => {
        const distance = Math.abs(position - this.dragStartScrollLeft);
        if (distance < nearestStartDistance) {
          nearestStartDistance = distance;
          startIndex = index;
        }
      });

      const direction = movedScroll > 0 ? 1 : -1;
      const targetIndex = Math.min(Math.max(startIndex + direction, 0), positions.length - 1);
      this.scrollToCardPosition(positions[targetIndex]);
    }

    snapToNearestCard() {
      if (!this.scroller) return;

      const positions = this.getCardPositions();
      if (!positions.length) return;

      let nearestScrollLeft = this.scroller.scrollLeft;
      let nearestDistance = Infinity;

      positions.forEach((position) => {
        const distance = Math.abs(position - this.scroller.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestScrollLeft = position;
        }
      });

      this.scrollToCardPosition(nearestScrollLeft);
    }

    cancelClick(event) {
      if (!this.dragMoved || !this.clickBlockActive) return;
      event.preventDefault();
      event.stopPropagation();
      this.dragMoved = false;
      this.clickBlockActive = false;
      window.clearTimeout(this.clickBlockTimer);
      window.removeEventListener('click', this.cancelClick, true);
    }

    updateScrollbar() {
      if (!this.scroller || !this.scrollbar || !this.scrollbarThumb) return;

      const scrollWidth = this.scroller.scrollWidth;
      const clientWidth = this.scroller.clientWidth;
      const maxScroll = Math.max(scrollWidth - clientWidth, 0);
      const trackWidth = this.scrollbar.getBoundingClientRect().width;

      this.scrollbar.style.display = 'block';

      if (!trackWidth || !scrollWidth || scrollWidth <= clientWidth) {
        this.scrollbarThumb.style.width = '100%';
        this.scrollbarThumb.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 48);
      const maxThumbLeft = Math.max(trackWidth - thumbWidth, 0);
      const scrollProgress = maxScroll > 0 ? this.scroller.scrollLeft / maxScroll : 0;
      const thumbLeft = Math.min(Math.max(scrollProgress * maxThumbLeft, 0), maxThumbLeft);

      this.scrollbarThumb.style.width = `${thumbWidth}px`;
      this.scrollbarThumb.style.transform = `translate3d(${thumbLeft}px, 0, 0)`;
    }

    handleChange(event) {
      const select = event.target.closest('[data-variant-select]');
      if (!select) return;

      const card = select.closest('[data-product-card]');
      const option = select.options[select.selectedIndex];
      if (!card || !option) return;

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const savePrice = card.querySelector('[data-save-price]');
      const image = card.querySelector('.product-scroll-card__image');
      const addButton = card.querySelector('.product-scroll-card__add');
      const variantLinks = card.querySelectorAll('[data-variant-link]');

      if (currentPrice) currentPrice.textContent = option.dataset.price || '';

      if (comparePrice) {
        comparePrice.textContent = option.dataset.compare || '';
        comparePrice.classList.toggle('product-scroll-card__compare--hidden', option.dataset.hasCompare !== 'true');
      }

      if (saveBadge) {
        saveBadge.classList.toggle('product-scroll-card__badge--hidden', option.dataset.hasSave !== 'true');
      }

      if (savePrice) savePrice.textContent = option.dataset.save || '';

      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        if (option.dataset.imageSrcset) image.srcset = option.dataset.imageSrcset;
        image.sizes = '(min-width: 750px) var(--psc-image-width), 78vw';
        if (option.dataset.imageAlt) image.alt = option.dataset.imageAlt;
      }

      if (option.dataset.url) {
        variantLinks.forEach((link) => {
          link.href = option.dataset.url;
        });
      }

      if (addButton) addButton.disabled = option.disabled;
    }

    handleSubmit(event) {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;

      event.preventDefault();

      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      if (submitButton && submitButton.disabled) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const formData = new FormData(form);
      const scrollY = window.scrollY || window.pageYOffset || 0;
      window.cartDrawerScrollPosition = scrollY;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
      }

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(form);
        }
      }

      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(form);
          } else {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          }

          // Keep the theme header cart count (and free-shipping message) in sync.
          // The theme's other AJAX add-to-cart flows call this after rendering.
          if (typeof window.freeShippMsg === 'function') {
            window.freeShippMsg();
          } else if (typeof freeShippMsg === 'function') {
            freeShippMsg();
          }
        })
        .catch(() => {
          window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-disabled');
          }
        });
    }
  }

  if (!customElements.get('product-scroll-cards')) {
    customElements.define('product-scroll-cards', ProductScrollCards);
  }

  document.querySelectorAll('.product-scroll-cards').forEach((section) => {
    if (section.tagName.toLowerCase() !== 'product-scroll-cards') {
      const wrapper = document.createElement('product-scroll-cards');
      section.parentNode.insertBefore(wrapper, section);
      wrapper.appendChild(section);
      if (typeof wrapper.initScrollbar === 'function') wrapper.initScrollbar();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-pro-series-blocks"] && !Shopify.designMode) return;
  try {
    
  const initPromotionProSeries = (root = document) => {
    root.querySelectorAll('.promotion-pro-series-blocks').forEach((section) => {
      const blocksWrap = section.querySelector('[data-promotion-pro-blocks]');
      const products = Array.from(section.querySelectorAll('[data-promotion-pro-product]'));

      const bindCartForms = () => {
        section.querySelectorAll('.promotion-pro-product__form').forEach((form) => {
          if (form.dataset.promotionProCartReady === 'true') return;
          form.dataset.promotionProCartReady = 'true';

          form.addEventListener('submit', (event) => {
            event.preventDefault();

            const submit = event.submitter || form.querySelector('[data-promotion-pro-submit]');
            if (submit && submit.disabled) return;

            const cartDrawer = document.querySelector('cart-drawer');
            const formData = new FormData(form);
            const submitWasDisabled = submit ? submit.disabled : false;
            const scrollY = window.scrollY || window.pageYOffset || 0;
            window.cartDrawerScrollPosition = scrollY;

            if (submit) {
              submit.disabled = true;
              submit.classList.add('is-loading');
              submit.setAttribute('aria-busy', 'true');
              submit.setAttribute('aria-disabled', 'true');
            }

            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              formData.append('sections', cartDrawer.getSectionsToRender().map((cartSection) => cartSection.id));
              formData.append('sections_url', window.location.pathname);
              if (typeof cartDrawer.setActiveElement === 'function') {
                cartDrawer.setActiveElement(document.activeElement);
              }
            }

            fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/javascript'
              },
              body: formData
            })
              .then((response) => {
                if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
                return response.json();
              })
              .then((response) => {
                if (response.status) {
                  throw new Error(response.description || 'Unable to add this product to the cart.');
                }

                if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                  try {
                    cartDrawer.renderContents(response);
                  } catch (renderError) {
                    console.error('Unable to refresh the cart drawer contents:', renderError);
                    if (typeof cartDrawer.open === 'function') {
                      cartDrawer.open(submit || document.activeElement);
                    }
                  }
                } else if (cartDrawer && typeof cartDrawer.open === 'function') {
                  cartDrawer.open(submit || document.activeElement);
                } else {
                  window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
                  return;
                }

                if (typeof window.freeShippMsg === 'function') {
                  window.freeShippMsg();
                } else if (typeof freeShippMsg === 'function') {
                  freeShippMsg();
                }
              })
              .catch((error) => {
                console.error('Promotion product add to cart failed:', error);
              })
              .finally(() => {
                if (submit) {
                  submit.disabled = submitWasDisabled;
                  submit.classList.remove('is-loading');
                  submit.removeAttribute('aria-busy');
                  submit.removeAttribute('aria-disabled');
                }
              });
          });
        });
      };

      bindCartForms();

      products.forEach((product) => {
        const tagSlot = product.querySelector('[data-promotion-pro-tag-slot]');
        const childSource = product.querySelector('[data-promotion-pro-child-source]');
        const tags = childSource ? Array.from(childSource.querySelectorAll('[data-promotion-pro-tag]')) : [];
        const features = childSource ? Array.from(childSource.querySelectorAll('[data-promotion-pro-feature]')) : [];
        const variantOptions = childSource ? Array.from(childSource.querySelectorAll('.promotion-pro-product__variant-option-source')) : [];
        const variantOptionSlot = product.querySelector('[data-promotion-pro-variant-options]');

        if (variantOptionSlot && variantOptions.length > 0) {
          variantOptionSlot.replaceChildren(...variantOptions);
        }

        if (tagSlot && tags.length > 0) {
          tags.forEach((tag) => tagSlot.append(tag));
        }

        if (features.length > 0 && !product.querySelector('[data-promotion-pro-features]')) {
          const featureWrap = document.createElement('div');
          featureWrap.className = 'promotion-pro-product__features';
          featureWrap.dataset.promotionProFeatures = '';
          features.forEach((feature) => featureWrap.append(feature));
          product.append(featureWrap);
        }

        const featureWrap = product.querySelector('[data-promotion-pro-features]');
        if (featureWrap) {
          let featureShell = featureWrap.closest('[data-promotion-pro-features-shell]');

          if (!featureShell) {
            featureShell = document.createElement('div');
            featureShell.className = 'promotion-pro-product__features-shell';
            featureShell.dataset.promotionProFeaturesShell = '';
            featureWrap.insertAdjacentElement('beforebegin', featureShell);
            featureShell.append(featureWrap);
          }

          if (!product.querySelector('[data-promotion-pro-features-scrollbar]')) {
            const scrollbar = document.createElement('div');
            scrollbar.className = 'promotion-pro-product__features-scrollbar';
            scrollbar.dataset.promotionProFeaturesScrollbar = '';
            scrollbar.setAttribute('aria-hidden', 'true');

            const track = document.createElement('span');
            track.className = 'promotion-pro-product__features-scrollbar-track';

            const thumb = document.createElement('span');
            thumb.className = 'promotion-pro-product__features-scrollbar-thumb';

            track.append(thumb);
            scrollbar.append(track);
            featureShell.append(scrollbar);

            const updateFeatureScrollbar = () => {
              const scrollWidth = featureWrap.scrollWidth;
              const clientWidth = featureWrap.clientWidth;
              const maxScroll = Math.max(scrollWidth - clientWidth, 0);
              const trackWidth = track.clientWidth;

              if (!trackWidth || !scrollWidth || scrollWidth <= clientWidth) {
                scrollbar.hidden = true;
                thumb.style.width = '100%';
                thumb.style.transform = 'translateX(0)';
                return;
              }

              scrollbar.hidden = false;
              const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 48);
              const maxThumbLeft = Math.max(trackWidth - thumbWidth, 0);
              const scrollProgress = maxScroll > 0 ? featureWrap.scrollLeft / maxScroll : 0;
              const thumbLeft = scrollProgress * maxThumbLeft;

              thumb.style.width = `${thumbWidth}px`;
              thumb.style.transform = `translateX(${thumbLeft}px)`;
            };

            featureWrap.addEventListener('scroll', updateFeatureScrollbar, { passive: true });
            window.addEventListener('resize', updateFeatureScrollbar);
            featureWrap.querySelectorAll('img').forEach((image) => image.addEventListener('load', updateFeatureScrollbar));
            requestAnimationFrame(updateFeatureScrollbar);
            setTimeout(updateFeatureScrollbar, 150);
          }
        }
      });

      if (!blocksWrap || products.length === 0 || section.querySelector('[data-promotion-pro-nav]')) return;

      const nav = document.createElement('div');
      nav.className = 'promotion-pro-series-blocks__nav';
      nav.dataset.promotionProNav = '';
      nav.style.setProperty('--pps-product-count', products.length);

      const activate = (activeIndex) => {
        const buttons = Array.from(section.querySelectorAll('[data-promotion-pro-tab]'));
        let activeButton = null;

        products.forEach((product, index) => {
          const active = index === activeIndex;
          product.classList.toggle('is-active', active);
          product.toggleAttribute('hidden', !active);

          if (active) {
            const featureWrap = product.querySelector('[data-promotion-pro-features]');
            if (featureWrap) {
              featureWrap.dispatchEvent(new Event('scroll'));
            }
          }
        });

        buttons.forEach((button, index) => {
          const active = index === activeIndex;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) activeButton = button;
        });

        if (activeButton && nav.scrollWidth > nav.clientWidth) {
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const targetLeft = activeButton.offsetLeft - ((nav.clientWidth - activeButton.offsetWidth) / 2);
          const maxLeft = Math.max(nav.scrollWidth - nav.clientWidth, 0);

          nav.scrollTo({
            left: Math.min(Math.max(targetLeft, 0), maxLeft),
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
          });
        }
      };

      products.forEach((product, index) => {
        const button = document.createElement('button');
        const image = product.dataset.tabImage;
        const rawTitle = product.dataset.tabTitle || product.dataset.productTitle || `Product ${index + 1}`;
        const title = rawTitle.replace(/<br\s*\/?\s*>/gi, '\n');

        button.type = 'button';
        button.className = 'promotion-pro-series-blocks__nav-button';
        button.dataset.promotionProTab = index;
        button.setAttribute('aria-controls', product.id);
        button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

        if (image) {
          const img = document.createElement('img');
          img.className = 'promotion-pro-series-blocks__nav-image';
          img.src = image;
          img.alt = '';
          img.loading = 'lazy';
          button.append(img);
        }

        const label = document.createElement('span');
        label.className = 'promotion-pro-series-blocks__nav-title';
        label.textContent = title;
        button.append(label);

        button.addEventListener('click', () => {
          activate(index);
        });
        nav.append(button);
      });

      const header = section.querySelector('[data-promotion-pro-header]');
      if (header) {
        header.insertAdjacentElement('afterend', nav);
      } else {
        blocksWrap.prepend(nav);
      }

      activate(0);
      section.classList.add('promotion-pro-series-blocks--tabs-ready');
    });
  };

  initPromotionProSeries();
  document.addEventListener('shopify:section:load', (event) => initPromotionProSeries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-manual-tabs"] && !Shopify.designMode) return;
  try {
    
  function initUserManualTabs(section) {
    if (!section || section.dataset.installVideoTabsInitialized === 'true') return;
    section.dataset.installVideoTabsInitialized = 'true';

    const panelsContainer = section.querySelector('[data-install-video-panels]');
    if (panelsContainer) {
      section.querySelectorAll('[data-install-video-panel]').forEach((panel) => {
        panelsContainer.appendChild(panel);
      });
    }

    const tabs = [...section.querySelectorAll('[data-install-video-tab]')];
    const panels = [...section.querySelectorAll('[data-install-video-panel]')];
    const tabsList = section.querySelector('.install-video-tabs-list');
    const scrollbar = section.querySelector('.install-video-tabs-scrollbar');
    const scrollbarThumb = section.querySelector('.install-video-tabs-scrollbar-thumb');
    let scrollbarHideTimer;

    const updateTabsScrollbar = () => {
      if (!tabsList) return;
      const trackWidth = Math.max(0, tabsList.clientWidth - 8);
      const canScroll = tabsList.scrollWidth > tabsList.clientWidth;
      const thumbWidth = canScroll
        ? Math.max(32, trackWidth * tabsList.clientWidth / tabsList.scrollWidth)
        : trackWidth;
      const maxLeft = Math.max(0, trackWidth - thumbWidth);
      const scrollRange = tabsList.scrollWidth - tabsList.clientWidth;
      const thumbLeft = scrollRange > 0 ? tabsList.scrollLeft / scrollRange * maxLeft : 0;
      if (scrollbarThumb) {
        scrollbarThumb.style.width = `${thumbWidth}px`;
        scrollbarThumb.style.transform = `translateX(${thumbLeft}px)`;
      }
      if (scrollbar) {
        scrollbar.style.display = 'block';
        scrollbar.style.opacity = '1';
        scrollbar.style.visibility = 'visible';
      }
      tabsList.classList.toggle('has-tabs-scroll', canScroll);
    };

    const handleTabsScroll = () => {
      updateTabsScrollbar();
      if (!scrollbar) return;
      scrollbar.style.opacity = '1';
      scrollbar.style.visibility = 'visible';
      clearTimeout(scrollbarHideTimer);
      scrollbarHideTimer = window.setTimeout(() => {
        scrollbar.style.opacity = '0';
        scrollbar.style.visibility = 'hidden';
      }, 500);
    };

    let scrollbarDrag = null;
    const getScrollbarMetrics = () => {
      const trackWidth = Math.max(0, tabsList.clientWidth - 8);
      const thumbWidth = scrollbarThumb?.offsetWidth || trackWidth;
      const maxLeft = Math.max(0, trackWidth - thumbWidth);
      return { trackWidth, thumbWidth, maxLeft };
    };

    const startScrollbarDrag = (event) => {
      if (!tabsList || window.matchMedia('(min-width: 750px)').matches) return;
      const metrics = getScrollbarMetrics();
      scrollbarDrag = { pointerId: event.pointerId, startX: event.clientX, startLeft: tabsList.scrollLeft, maxLeft: metrics.maxLeft, scrollRange: tabsList.scrollWidth - tabsList.clientWidth };
      tabsList.setPointerCapture(event.pointerId);
      event.preventDefault();
    };

    const moveScrollbarDrag = (event) => {
      if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
      const delta = event.clientX - scrollbarDrag.startX;
      const ratio = scrollbarDrag.maxLeft > 0 ? scrollbarDrag.scrollRange / scrollbarDrag.maxLeft : 0;
      tabsList.scrollLeft = scrollbarDrag.startLeft + delta * ratio;
      event.preventDefault();
    };

    const stopScrollbarDrag = (event) => {
      if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
      scrollbarDrag = null;
      if (tabsList.hasPointerCapture(event.pointerId)) tabsList.releasePointerCapture(event.pointerId);
    };

    const centerTab = (tab) => {
      if (!tabsList || !tab || window.matchMedia('(min-width: 750px)').matches) return;
      const left = tab.offsetLeft - (tabsList.clientWidth - tab.offsetWidth) / 2;
      const maxLeft = tabsList.scrollWidth - tabsList.clientWidth;
      tabsList.scrollTo({ left: Math.max(0, Math.min(left, maxLeft)), behavior: 'smooth' });
      window.requestAnimationFrame(updateTabsScrollbar);
    };

    const selectTab = (id) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.installVideoTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.installVideoPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      centerTab(tabs.find((tab) => tab.dataset.installVideoTab === id));
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab.dataset.installVideoTab));
    });

    tabsList?.addEventListener('scroll', handleTabsScroll, { passive: true });
    scrollbarThumb?.addEventListener('pointerdown', startScrollbarDrag);
    tabsList?.addEventListener('pointermove', moveScrollbarDrag);
    tabsList?.addEventListener('pointerup', stopScrollbarDrag);
    tabsList?.addEventListener('pointercancel', stopScrollbarDrag);
    window.addEventListener('resize', updateTabsScrollbar);

    if (tabs[0]) selectTab(tabs[0].dataset.installVideoTab);
    updateTabsScrollbar();
  }

  document.querySelectorAll('[data-install-video-tabs]').forEach(initUserManualTabs);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-install-video-tabs]').forEach(initUserManualTabs);
  });

  } catch(e) { console.error(e); }
})();
})();
